

const initialCodingNav = {
  isActive: false,
  testId: null,
  history: [],
  currentIndex: 0,
};

export function codingNavReducer(state = initialCodingNav, action) {
  switch (action.type) {

    case "CODING_NAV_INIT":
      return {
        isActive: true,
        testId: action.payload.testId,
        history: [action.payload.question],
        currentIndex: 0,
      };

    case "CODING_NAV_PERSIST_CURRENT":
      return {
        ...state,
        history: state.history.map((q, i) =>
          i === state.currentIndex
            ? { ...q, editorState: action.payload.editorState }
            : q
        ),
      };

    case "CODING_NAV_APPEND":
      return {
        ...state,
        history: [...state.history, action.payload],
        currentIndex: state.currentIndex + 1,
      };

    case "CODING_NAV_NEXT":
      return {
        ...state,
        currentIndex: state.currentIndex + 1,
      };

    case "CODING_NAV_PREV":
      return {
        ...state,
        currentIndex: state.currentIndex - 1,
      };

    case "CODING_NAV_MARK_SUBMITTED":
      return {
        ...state,
        history: state.history.map((q, i) =>
          i === state.currentIndex ? { ...q, submitted: true } : q
        ),
      };

    case "CODING_NAV_RESET":
      return initialCodingNav;

    case "CODING_NAV_UPDATE_STARTER_CODE":
      return {
        ...state,
        history: state.history.map((q, i) =>
          i === state.currentIndex
            ? {
                ...q,
                editorState: {
                  ...q.editorState,
                  code: action.payload,
                },
              }
            : q
        ),
      };

    default:
      return state;
  }
}